class ViewTutorialType {
    static DISPLAY = 1;
    static DISABLE  = 2;
  }
  
  export default ViewTutorialType;
  